export default __webpack_public_path__ + "static/media/BR.f87b81d0.svg";